module.exports = require("instafeed.js");


//////////////////
// WEBPACK FOOTER
// external "instafeed.js"
// module id = 154
// module chunks = 0